<template>
    <div>
        <div class="vx-row">
            <vs-card>
                <div slot="header">
                    <h5>Plainte reçue par mail et par CCMT par période</h5>
                </div>
                <vs-row>
                    <vs-col>
                        <div class="flex -mx-2">
                            <div class="w-2/4 px-2">
                                <span class="vs-select--label">Période</span>
                                <date-range-picker
                                    ref="picker"
                                    :opens="opens"
                                    :locale-data=locale
                                    :singleDatePicker="false"
                                    :timePicker=false
                                    :showWeekNumbers="showWeekNumbers"
                                    :showDropdowns="showDropdowns"
                                    :autoApply="autoApply"
                                    v-model="dateRange"
                                    :ranges=false
                                    @update="updateValues"
                                    :linkedCalendars="linkedCalendars"
                                    :dateFormat="dateFormat"
                                    :always-show-calendars="false"
                                    :alwaysShowCalendars="alwaysShowCalendars"
                                    class="vs-inputx vs-input--input"
                                >
                                    <div slot="input" slot-scope="picker" style="min-width: 350px;">
                                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                    </div>
                                </date-range-picker>
                            </div>
                            <div class="w-1/8 px-2">
                                <vs-button :disabled="dateRange.startDate === '' && dateRange.endDate === ''" @click="makeSearch()" style="margin-top: 18px;" color="primary"
                                            type="filled" icon="search">Recherche
                                </vs-button>
                            </div>
                            <!-- <div class="w-1/8 px-2">
                                <vs-button :disabled="dateRange.startDate === '' && dateRange.endDate === ''" @click="exportData()" style="margin-top: 18px;" color="primary"
                                            type="filled" icon="cloud_download">Exporter
                                </vs-button>
                            </div> -->
                        </div>
                    </vs-col>
                </vs-row>
            </vs-card>
        </div>

        <div class="app-dashboard">

            <div class="vx-row">
                <div style="cursor:pointer" class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                    <vx-card class="overflow-hidden" card-background="primary"
                            content-color="#fff">
                        <div slot="no-body">
                            <div class="p-6 flex justify-between flex-row-reverse items-center">
                            <div class="truncate">
                                <h2 class="mb-1 font-bold text-white"> {{total_ccmt}} </h2>
                                <span>Total CCMT</span>
                            </div>
                            </div>
                        </div>
                    </vx-card>
                </div>

                <div style="cursor:pointer" class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                    <vx-card class="overflow-hidden">
                        <div slot="no-body">
                            <div class="p-6 flex justify-between flex-row-reverse items-center">
                            <div class="truncate">
                                <h2 class="mb-1 font-bold"> {{ total_mail }} </h2>
                                <span>Total mail</span>
                            </div>
                            </div>
                        </div>
                    </vx-card>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
export default {
    name : "totalRequest",
    components: {DateRangePicker},
    data: () => ({
        total_ccmt: 0,
        total_mail: 0,
        user: 0,
        stats: [],
        requests: [],
        last_page: null,
        page: 1,
        opens: 'center',
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,
        showDropdowns: true,
        autoApply: false,
        locale: {
            direction: 'ltr',
            format: 'dd/mm/yyyy',
            separator: ' - ',
            applyLabel: 'Appliquer',
            cancelLabel: 'Annuler',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 0
        },
        dateRange: {
            startDate: "",
            endDate: "",
        },
        dateFormat(classes, date) {
            let yesterday = moment().subtract(1, 'day');
            if (!classes.disabled) {
            }
        return classes
        },
    }),
    mounted(){
        this.dateRange.startDate = moment(new Date()).format('YYYY-MM-DD')
        this.dateRange.endDate = moment(new Date()).format('YYYY-MM-DD')
        this.makeSearch()
    },
    methods:{
        updateValues(values) {
            this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
            this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
        },

        makeSearch() {
            this.$vs.loading()
            this.$http.post('/ebu/total-request-by-group?export=0', {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
            }).then((response) => {
            let content = response.data
            this.total_ccmt = content.total_ccmt;
            this.total_mail = content.total_mail;
            this.$vs.loading.close()
            }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    console.log(error)
                }
            })
        },

        exportData(){
            this.$vs.loading()
            this.$http.post('/ebu/total-request-by-group?export=1', {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
            }, {
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = link.href = url
                link.setAttribute('download', 'totalByGroup.xlsx')
                document.body.appendChild(link)
                link.click()
                this.customer = ''
                this.$vs.loading.close()
            }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401) {
                this.$vs.notify({
                    title: 'Erreur',
                    text: 'Votre session a expiré',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    position: 'top-right'
                })
                this.$router.push({name: "login"})
                }
            })
        }
    }
}
</script>

<style lang="scss">
  @import "@/assets/scss/vuesax/components/vxTimeline.scss";
</style>
